module.exports = "## How to compress a photo\r\n\r\nFollow these two steps to compress single or bulk images"


//////////////////
// WEBPACK FOOTER
// ./src/containers/Features/PhotoCompress/photo-compress-how-to-header.md
// module id = 1155
// module chunks = 0